import {
    DashboardWidgetModel,
    DashboardWidgetType
} from '@/atomic-components/organs/dashboard-widgets/dashboard-widget-model';
import {
    DashboardWidgetObjectDefinition
} from '@/atomic-components/organs/dashboard-widgets/dashboard-widget-model-operator';

export class DashboardWidgetIncompleteUserProfileModel extends DashboardWidgetModel {
    public static $inject: string[] = DashboardWidgetModel.$inject.concat([]);

    public static dashboardWidgetDefinition: DashboardWidgetObjectDefinition = {
        demoData: {},
        manualAddable: false,
        userPermissions: null,
        systemNotification: 'completeBasicData',
        widgetDescription: [],
        widgetObject: {
            attribute: {
                id: 'organDashboardWidgetIncompleteUserProfile',
                width: 2,
                height: 1,
                locked: true,
                noResize: true,
                noMove: true,
                autoPosition: true
            },
            componentTagName: 'organ-dashboard-widget-incomplete-user-profile',
            widgetModel: 'dashboardWidgetIncompleteUserProfileModel',
            version: '1.0'
        },
        widgetTitle: /* translationId */ 'TR_290121-3bc59d_TR',
        widgetType: DashboardWidgetType.system
    };

    public dashboardWidgetDefinition: DashboardWidgetObjectDefinition;

    constructor() {
        super();

        this.dashboardWidgetDefinition = DashboardWidgetIncompleteUserProfileModel.dashboardWidgetDefinition;
    }
}

